module.exports = __webpack_public_path__ + "static/img/12.4ef0882c.png";